import React from 'react';

const TechTeam = () => {
  return (
    <div className="min-h-screen bg-gray-50 ">
      <div className="max-w-7xl mx-auto ">
        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
          {/* Header */}
          <div className="bg-accent text-white px-6 py-8">
            <h1 className="text-3xl font-bold text-center text-white">Technical Team</h1>
            <p className="text-center mt-2 text-accent-light">
              AIM Journal of Homoeopathic Medicine (AJHM)
            </p>
          </div>

          {/* Content */}
          <div className="px-6 py-8">
            <div className="prose prose-lg max-w-none">
              <div className="space-y-8">
                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-6">Meet Our Technical Team</h2>
                  <p className="text-gray-700 leading-relaxed mb-8">
                    Our dedicated technical team ensures the smooth operation and continuous improvement 
                    of the AIM Homoeopathy Journal platform, providing a seamless experience for authors, reviewers, and readers.
                  </p>
                  
                  {/* Team Members Grid */}
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* Team Member 1 */}
                    <div className="text-center">
                      <div className="w-48 h-48 mx-auto mb-4 bg-gray-200 rounded-full flex items-center justify-center">
                        <span className="text-gray-500 text-4xl">👤</span>
                      </div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-2">John Doe</h3>
                      <p className="text-gray-600 mb-3">Lead Developer</p>
                      <p className="text-sm text-gray-500">
                        Full-stack development and system architecture
                      </p>
                    </div>

                    {/* Team Member 2 */}
                    <div className="text-center">
                      <div className="w-48 h-48 mx-auto mb-4 bg-gray-200 rounded-full flex items-center justify-center">
                        <span className="text-gray-500 text-4xl">👤</span>
                      </div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-2">Jane Smith</h3>
                      <p className="text-gray-600 mb-3">UI/UX Designer</p>
                      <p className="text-sm text-gray-500">
                        User experience and interface design
                      </p>
                    </div>

                    {/* Team Member 3 */}
                    <div className="text-center">
                      <div className="w-48 h-48 mx-auto mb-4 bg-gray-200 rounded-full flex items-center justify-center">
                        <span className="text-gray-500 text-4xl">👤</span>
                      </div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-2">Mike Johnson</h3>
                      <p className="text-gray-600 mb-3">DevOps Engineer</p>
                      <p className="text-sm text-gray-500">
                        Infrastructure and deployment management
                      </p>
                    </div>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">Contact Our Tech Team</h2>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <p className="text-gray-700 mb-4">
                      For technical support, feature requests, or any platform-related inquiries, 
                      please reach out to our technical team:
                    </p>
                    <div className="space-y-2">
                      <p className="text-gray-700">
                        <strong>Technical Support:</strong> tech@ahmj.org
                      </p>
                      <p className="text-gray-700">
                        <strong>Response Time:</strong> Within 24-48 hours
                      </p>
                      <p className="text-gray-700">
                        <strong>Priority Issues:</strong> Immediate response for critical system issues
                      </p>
                    </div>
                  </div>
                </section>

                <div className="border-t pt-6 mt-8">
                  <p className="text-sm text-gray-500 text-center">
                    Last updated: {new Date().toLocaleDateString()}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechTeam; 